// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HGry","content":"styles_content__1x8cM"};